import React                from 'react';
import PropTypes            from 'prop-types';
import Flux                 from '../../../flux/Flux';
import Translations         from '../../../utils/Translations';
import TextInput            from "../../Text/TextInput";
import CircleLoader         from "../../Loader/CircleLoader";
import {VXPay, VXPayAction} from '../../../utils/VXPay';


class Note extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isExist:   this.props.isExist,
			isShowing: this.props.isShowing,
			isLoading: this.props.isShowing,
			lastSaved: Flux.Actor.getActorNote(this.props.actorId)?.comment,
		};

		this.setFocus          = this.setFocus.bind(this);
		this.onActorNoteChange = this.onActorNoteChange.bind(this);
		this.onShowHideClicked = this.onShowHideClicked.bind(this);
		this.onWindowClick     = this.onWindowClick.bind(this);
		this.onClearClicked    = this.onClearClicked.bind(this);
		this.toggleWrapper     = this.toggleWrapper.bind(this);
		this.unsetAfterLogin   = this.unsetAfterLogin.bind(this);
		this.actorNoteComment  = null;
	}

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.isExist !== prevState.isExist) {
			return {
				isExist: nextProps.isExist,
			};
		}
        return null;
    }

	componentDidMount() {
		this.loadActorNote();
		if (this.props.autoClose) {
			window.addEventListener('click', this.onWindowClick);
		}
		Flux.Actor.addActorNoteChangeListener(this.onActorNoteChange);

		if (this.props.isShowing) {
			this.loadActorNote();
		}

		if (Flux.Browser.getLocalItem('NoteactorId')) {
			this.toggleWrapper();
			this.intervalID = setInterval(
				() => this.unsetAfterLogin(),
				2000
			);
		}

		if(this.state.lastSaved !== null && this.state.lastSaved?.length > 0) {
			this.setState({
				isExist: true,
			});
		}
	}

	componentWillUnmount() {
		if (this.props.autoClose) {
			window.removeEventListener('click', this.onWindowClick);
		}
		Flux.Actor.removeActorNoteChangeListener(this.onActorNoteChange);

	}

	unsetAfterLogin() {
		if (!this.state.isShowing && Flux.Browser.getLocalItem('NoteactorId')) {
			Flux.Browser.removeLocalItem('NoteactorId');
		} else if (!Flux.Browser.getLocalItem('NoteactorId')) {
			this.setState({
				isShowing: false,
			});
			clearInterval(this.intervalID);
		}
	}

	onWindowClick() {
		if (this.state.isShowing) {
			this.toggleWrapper();
		}
	}

	onActorNoteChange() {
		const actorNote = Flux.Actor.getActorNote(this.props.actorId);
		this.setState({
			isLoading: false,
		});

		if (typeof actorNote !== 'undefined' && actorNote) {
			if (this.actorNoteComment) {
				this.actorNoteComment.setValue(actorNote.comment);
			}
			this.setState({
				isExist: actorNote.comment.length > 0,
			});
		}
	}

	toggleWrapper() {
		if (!Flux.Guest.isLoggedIn()) {
			const action = new VXPayAction(Flux.Constants.ActionTypes.Actor.LOAD_NOTE, {
				targetId:             this.props.actorId,
				storeAutoOpenSetting: true,
			});
			VXPay.openSignupOrLogin({
				host: this.props.actorId,
			}, action);
		} else {
			if (!this.state.isLoading) {
				this.setState({
					isLoading: true,
				});
			}
			if (this.state.isShowing) {
				this.storeActorNote();
			} else {
				this.actorNoteComment.setValue('');
				this.loadActorNote();
			}
			this.setState({
				isShowing: !this.state.isShowing,
			});
		}
	}

	storeActorNote() {
		const newText = this.actorNoteComment.getPlainText();
		if (newText === this.state.lastSaved) {
			return;
		}

		Flux.Actor.storeActorNote(this.props.actorId, this.actorNoteComment.getPlainText());
		this.setState({
			lastSaved: newText,
		});
	}

	loadActorNote() {
		if (Flux.Guest.isLoggedIn()) {
			const actorNote = Flux.Actor.getActorNote(this.props.actorId);
			if (typeof actorNote !== 'undefined' && actorNote) {
				this.onActorNoteChange();
			} else {
				Flux.Actor.loadActorNote(this.props.actorId);
			}
		}
	}

	onShowHideClicked(e) {
		if (typeof e === 'object' && e.cancelable) {
			e.preventDefault();
			e.stopPropagation();
		}

		this.toggleWrapper();
	}

	onClearClicked(e) {
		if (typeof e === 'object' && e.cancelable) {
			e.preventDefault();
			e.stopPropagation();
		}

		this.actorNoteComment.setValue('');

		this.setState({
			isExist: false,
		});

		this.setFocus();
	}

	setFocus() {
		if (this.state.isShowing && !this.state.isLoading) {
			this.actorNoteComment.setFocus();
		}
	}

	render() {
		const icon               = <i data-tooltip-content={Translations.get('ActorNote')} data-tooltip-id="tooltip"
		                              className={this.state.isExist ? 'icon -icon-note-full' : 'icon -icon-note-line'}
		/>;
		const containerClassName = 'actor-note' + (this.state.isShowing ? ' -opened' : '');
		const wrapperClassName   = 'actor-note-wrapper' + (this.state.isShowing ? '' : ' h-hide');
		const placeholder        = Translations.get('ActorNotePlaceholder');

		let circleLoader = null;
		if (this.state.isLoading) {
			circleLoader = <CircleLoader className={"-grey"}/>;
		}

		return (
			<div className={containerClassName} onClick={(e) => e.stopPropagation()}>
				<div className="toggle-icon h-cursor-pointer"
				     onClick={this.onShowHideClicked}
				>
					{icon}
				</div>
				<div className={wrapperClassName}>
					<div className="title">{Translations.get('ActorNoteTitle')}</div>
					<div className="icon -icon-close-full" onClick={this.onShowHideClicked}/>
					<div className="icon -icon-trash-full" onClick={this.onClearClicked}/>
					<div className="editor" onClick={this.setFocus}>
						<TextInput
							maxLength={3500}
							readOnly={false}
							ref={ref => this.actorNoteComment = ref}
							displayRemainingChars={false}
							value={''}
							textInputPlaceholder={placeholder}
							editorContainerClassName="actor-note__input -no-margin -no-border"
							rows={11}
							onSubmit={() => {
							}}
						/>
						{circleLoader}
					</div>
				</div>
			</div>
		);
	}

}

Note.defaultProps = {
	actorId:   null,
	isExist:   false,
	isShowing: false,
	autoClose: true,
};

Note.propTypes = {
	actorId:   PropTypes.number.isRequired,
	isExist:   PropTypes.bool.isRequired,
	isShowing: PropTypes.bool,
	autoClose: PropTypes.bool,
};

export default Note;
